import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Phone, Mail, MapPin, Facebook, Instagram, Linkedin, ArrowRight } from 'lucide-react';
import { serviceAreas } from '../data/areas';

const services = [
  { name: 'Kitchen Renovation', path: '/services/kitchen-renovation-westchester' },
  { name: 'Bathroom Remodeling', path: '/services/bathroom-remodeling-westchester' },
  { name: 'Home Additions', path: '/services/home-additions-westchester' },
  { name: 'Custom Wine Cellars', path: '/services/wine-cellars-westchester' }
];

const quickLinks = [
  { name: 'About Us', path: '/about' },
  { name: 'Services', path: '/services' },
  { name: 'Blog', path: '/blog' },
  { name: 'Contact', path: '/contact' },
  { name: 'Get Estimate', path: '/consultation' }
];

const socialLinks = [
  { name: 'Facebook', icon: Facebook, url: 'https://www.facebook.com/renovationwestchester' },
  { name: 'Instagram', icon: Instagram, url: 'https://www.instagram.com/renovationwestchester' },
  { name: 'LinkedIn', icon: Linkedin, url: 'https://www.linkedin.com/company/renovation-westchester' }
];

export function Footer() {
  return (
    <footer className="border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <Building2 className="h-6 w-6 text-yellow-400" />
              <span className="text-xl font-light tracking-wider text-zinc-100">
                GOLDEN TOUCH <span className="font-medium">CONTRACTING CORP</span>
              </span>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Premier construction and renovation services in Westchester County, NY and Fairfield County, CT. 
              Delivering excellence since 2010.
            </p>
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-zinc-400 hover:text-yellow-400 transition-colors"
                  aria-label={social.name}
                >
                  <social.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-zinc-100 font-medium mb-6">Our Services</h3>
            <ul className="space-y-4">
              {services.map((service) => (
                <li key={service.name}>
                  <Link
                    to={service.path}
                    className="text-zinc-400 hover:text-yellow-400 transition-colors text-sm flex items-center gap-2 group"
                  >
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-zinc-100 font-medium mb-6">Quick Links</h3>
            <ul className="space-y-4">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-zinc-400 hover:text-yellow-400 transition-colors text-sm flex items-center gap-2 group"
                  >
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-zinc-100 font-medium mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:9149606433"
                  className="text-zinc-400 hover:text-yellow-400 transition-colors text-sm flex items-center gap-2"
                >
                  <Phone className="h-4 w-4" />
                  (914) 960-6433
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@renovationwestchester.com"
                  className="text-zinc-400 hover:text-yellow-400 transition-colors text-sm flex items-center gap-2"
                >
                  <Mail className="h-4 w-4" />
                  info@renovationwestchester.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-zinc-400 mt-1 flex-shrink-0" />
                <span className="text-zinc-400 text-sm">
                  Serving Westchester County, NY<br />
                  and Fairfield County, CT
                </span>
              </li>
              <li className="flex flex-wrap gap-x-3 gap-y-2 pt-2">
                {serviceAreas.map((area) => (
                  <Link
                    key={area.slug}
                    to={`/areas/${area.slug}`}
                    className="text-zinc-500 hover:text-yellow-400 transition-colors text-sm"
                  >
                    {area.name}
                  </Link>
                ))}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-zinc-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-zinc-500 text-sm">
              © {new Date().getFullYear()} Golden Touch Contracting Corp. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-sm">
              <span className="text-zinc-500">Created by</span>
              <a
                href="https://kastech.solutions"
                target="_blank"
                rel="noopener noreferrer"
                className="text-yellow-400 hover:text-yellow-300 transition-colors"
              >
                KasTech Solutions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}